<script lang="ts">
  import { _ } from 'svelte-i18n';
  import PageHeader from '../lib/components/layout/PageHeader.svelte';
  import { Card } from '../lib/components/ui/index';
  import { api } from '../lib/api';
  import type { PrivacyPolicyResponse } from '../lib/api/settings';

  let controller: PrivacyPolicyResponse['controller'] | null = null;
  let controllerFailed = false;

  api.settings
    .getPrivacyPolicy()
    .then((policy) => (controller = policy.controller))
    .catch(() => (controllerFailed = true));
</script>

<PageHeader title={$_('pages.settings.privacy_policy_title')} subtitle="" />

<div class="max-w-3xl">
  <Card>
    <div class="prose prose-sm text-text max-w-none space-y-4">
      <p class="text-xs text-text-muted">{$_('privacy_policy.last_updated')}</p>

      <h3 class="text-base font-semibold">{$_('privacy_policy.controller_title')}</h3>
      <div>
        {#if controller}
          <p class="text-sm text-text-secondary whitespace-pre-line">
            {[controller.name, controller.address, controller.email].join('\n')}
          </p>
        {:else if controllerFailed}
          <p class="text-sm text-text-secondary">{$_('privacy_policy.controller_unavailable')}</p>
        {:else}
          <div
            data-testid="privacy-controller-skeleton"
            class="h-4 w-48 animate-pulse rounded bg-surface-hover"
          ></div>
        {/if}
      </div>

      <h3 class="text-base font-semibold">{$_('privacy_policy.overview_title')}</h3>
      <p class="text-sm text-text-secondary">{$_('privacy_policy.overview_text')}</p>

      <h3 class="text-base font-semibold">{$_('privacy_policy.auth_title')}</h3>
      <p class="text-sm text-text-secondary">{$_('privacy_policy.auth_text')}</p>

      <h3 class="text-base font-semibold">{$_('privacy_policy.documents_title')}</h3>
      <p class="text-sm text-text-secondary">{$_('privacy_policy.documents_text')}</p>

      <h3 class="text-base font-semibold">{$_('privacy_policy.ai_title')}</h3>
      <p class="text-sm text-text-secondary">{$_('privacy_policy.ai_text')}</p>

      <h3 class="text-base font-semibold">{$_('privacy_policy.chat_title')}</h3>
      <p class="text-sm text-text-secondary">{$_('privacy_policy.chat_text')}</p>

      <h3 class="text-base font-semibold">{$_('privacy_policy.feedback_title')}</h3>
      <p class="text-sm text-text-secondary">{$_('privacy_policy.feedback_text')}</p>

      <h3 class="text-base font-semibold">{$_('privacy_policy.technical_title')}</h3>
      <p class="text-sm text-text-secondary">{$_('privacy_policy.technical_text')}</p>

      <h3 class="text-base font-semibold">{$_('privacy_policy.recipients_title')}</h3>
      <p class="text-sm text-text-secondary">{$_('privacy_policy.recipients_text')}</p>

      <h3 class="text-base font-semibold">{$_('privacy_policy.transfers_title')}</h3>
      <p class="text-sm text-text-secondary">{$_('privacy_policy.transfers_text')}</p>

      <h3 class="text-base font-semibold">{$_('privacy_policy.rights_title')}</h3>
      <p class="text-sm text-text-secondary whitespace-pre-line">
        {$_('privacy_policy.rights_text')}
      </p>

      <h3 class="text-base font-semibold">{$_('privacy_policy.authority_title')}</h3>
      <p class="text-sm text-text-secondary">{$_('privacy_policy.authority_text')}</p>

      <h3 class="text-base font-semibold">{$_('privacy_policy.cookies_title')}</h3>
      <p class="text-sm text-text-secondary">{$_('privacy_policy.cookies_text')}</p>
    </div>
  </Card>
</div>
